export default __webpack_public_path__ + "static/media/trade-icon.1bdded0b.svg";